import React, { useState } from "react";
import "./mobfilter.css";

import { BiFilterAlt } from "react-icons/bi";
import Form from "react-bootstrap/Form";
import * as AiIcons from "react-icons/ai";
import SearchContext from "../../context/SearchContext";
import { useContext } from "react";
import { baseUrl } from "../../context/BaseUrl";
import { useEffect } from "react";
import { Accordion, FormSelect } from "react-bootstrap";
import MobSortV from "./MobSortV";


const MobFilterV = ({ category_id, handle, sortHandle, catHandle }) => {
  const { search, setSearch } = useContext(SearchContext);
  const [result, setResult] = useState(false);
  const { category, setCategory } = catHandle;
  const [options, setOptions] = useState([]);
  const { sort, setSort } = sortHandle;
  const [subject, setSubject] = useState([]);
  const [filter, setFilter] = useState(false);
  const [data, setData] = useState(false);
  const [citydata, setCitydata] = useState(false);
  const [show, setShow] = useState(false);
  const [price, setPrice] = useState("");
  const handlerange = (e) => {
    setPrice(e.target.value);
    setSearch({ ...search,  budget_max: e.target.value })
  };
  const [rate, setRate] = useState(0);
  const loadExam = async () => {
    const dataExam = await fetch(
      `${baseUrl}/user/category/getcategory_details/${category_id}`
    );
    const subject = await dataExam.json();

    setResult(subject);
  };
  useEffect(() => {
    loadExam();
  }, []);

  const handlestate = (e) => {
    const value = e.target.value;
    const state_obj = data[0].states.filter((val, i)=> val.state_id == value );
    const CityApi = async () => {

      const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/districts/${state_obj[0].state_id}`, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result.error) {
        console.warn("got an error in response", result.error);
        return;
      }
        setCitydata([result]);
    };
    CityApi();
  };

  const ApiPost = async () => {

    const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/states`, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.error) {
      console.warn("got an error in response", result.error);
      return;
    }
      setData([result]);
  };
  
  useEffect(() => {
  ApiPost();
}, []);
useEffect(() => {
  setSearch({...search, 
    rating: rate,
    budget_max: price,
    sort: "namea",
 })
}, [citydata, rate]);
 
const handleCourse = (e) => {
  const subName = e.target.id;
  const sub = e.target.checked;

  if (sub){
    subject.push(subName)
  }
  if(!sub){
    const remove = subject.findIndex((item) => item == subName);
    subject.splice(remove, 1)
  }
  setSearch({ ...search, subject: subject })
}

const fetchCategories = async () => {
  const response = await fetch(`${baseUrl}/admin/vacancy/get`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  const result = await response.json();

  console.log("categories", result);
  setOptions(result);
};

useEffect(() => {
  fetchCategories();
}, []);

  return (
    <>
      <div className="filter-mob mb-5">
        <div className="table-filter">
          <MobSortV search={search} setSearch={setSearch} sortHandle={{ sort, setSort }} />
          <div className="filter-popup">
            <div className="filter" onClick={() => setFilter(!filter)}>
              <BiFilterAlt className="filter" /> Filter
            </div>
            {filter ? (
              <div className="popupshow">
                <h3>
                  Filters{" "}
                  <AiIcons.AiOutlineClose onClick={() => setFilter(!filter)} />
                </h3>

                <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Category</Accordion.Header>
                  <Accordion.Body>
                    <Form>
                      <Form.Select
                        className="mb-3"
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="">Select Category</option>
                        {options.map((item) => (
                          <option value={item.name}>
                            {item.name.toUpperCase()}
                          </option>
                        ))}
                      </Form.Select>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
                <div className="filterBtns">
                  <button className="cancel" onClick={() => setFilter(!filter)}>Cancel</button>
                  <button className="apply" onClick={() => setFilter(!filter)}>Apply</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobFilterV;
